import { Map } from 'immutable';
import { ACTIVE_QUIZ_SESSION_CHANGE, UPDATE_TIMER_INFO, UPDATE_IS_TAKING, UPDATE_QUIZ_SESSION_STATUS_ON_PAGE_LOAD, UPDATE_TIMER_MINIMIZED, LOAD_RESUME_DATA, PREVIEW_RESPONSE, PREVIOUS_QUESTION, BACKTRACKING_NEXT_QUESTION, RESPONSE, SESSION_STARTED_OR_RESUMED_EVENT, SET_CURRENT_SESSION_ITEM_POSITION, CLEAR_FOCUS_CURRENT_SESSION_ITEM, SET_FOCUS_TITLE_AND_INSTRUCTIONS, UPDATE_QUIZ_SUBMIT_FLAG, SET_WS_TOKEN } from '@instructure/quiz-common';
var defaultResponse = function defaultResponse(payload) {
  return Map({
    position: payload.position,
    itemId: payload.itemId,
    userResponse: payload.userResponse || {},
    clientTimestamp: Date.now(),
    invalid: payload.invalid
  });
};
var cachedSessionIsCurrent = function cachedSessionIsCurrent(state, payload) {
  return state.get('sessionIdForCurrentItem') === payload;
};
var activeQuizSessionChange = function activeQuizSessionChange(state, payload) {
  if (cachedSessionIsCurrent(state, payload)) {
    return state;
  } else {
    return state.clear();
  }
};
var updateQuizSessionStatusOnPageLoad = function updateQuizSessionStatusOnPageLoad(state, payload) {
  return state.set('quizSessionStatusOnPageLoad', payload.quizSessionStatusOnPageLoad);
};
var setCurrentSessionItemPosition = function setCurrentSessionItemPosition(state, payload) {
  return state.set('currentSessionItemPosition', payload.position).set('focusCurrentSessionItem', true);
};
var clearFocusCurrentSessionItem = function clearFocusCurrentSessionItem(state, payload) {
  return state.set('focusCurrentSessionItem', false);
};
var previousQuestion = function previousQuestion(state, payload) {
  var currentPosition = state.get('currentSessionItemPosition');
  return state.set('currentSessionItemPosition', currentPosition - 1);
};
var backtrackingNextQuestion = function backtrackingNextQuestion(state, payload) {
  var currentPosition = state.get('currentSessionItemPosition', 1);
  return state.set('currentSessionItemPosition', currentPosition + 1);
};
var updateIsTaking = function updateIsTaking(state, payload) {
  return state.set('isTaking', payload.isTaking);
};
var updateTimerInfo = function updateTimerInfo(state, payload) {
  return state.mergeIn(['timerData'], payload);
};
var setWSToken = function setWSToken(state, payload) {
  return state.set('wsToken', payload === null || payload === void 0 ? void 0 : payload.wsToken);
};
var updateTimerMinimized = function updateTimerMinimized(state, payload) {
  return state.setIn(['timerData', 'timerMinimized'], payload.timerMinimized);
};
var getResponse = function getResponse(payload, state) {
  return state.getIn(['responses', payload.position]) || defaultResponse(payload);
};
var mergeModifiedResponse = function mergeModifiedResponse(state, payload) {
  var responseMap = Map([[payload.get('position'), payload]]);
  return state.mergeIn(['responses'], responseMap);
};
var modifyResponse = function modifyResponse(state, payload) {
  var response = getResponse(payload, state);
  var responseWithMods = response.merge(payload);
  return mergeModifiedResponse(state, responseWithMods);
};
var loadResponses = function loadResponses(state, payload) {
  if (payload.length === 0) {
    return state.set('responses', Map());
  }
  return payload.reduce(modifyResponse, state);
};
var markSessionStartedIdentifier = function markSessionStartedIdentifier(state, payload) {
  var needsUpdate = state.get('browserSessionId') !== payload.browserSessionId || state.get('ipAddress') !== payload.ipAddress;
  return needsUpdate ? state.merge({
    browserSessionId: payload.browserSessionId,
    ipAddress: payload.ipAddress
  }) : state;
};
var updateQuizSubmitFlag = function updateQuizSubmitFlag(state, payload) {
  return state.set('submitFlag', payload.value);
};
var setFocusTitleAndInstructions = function setFocusTitleAndInstructions(state, payload) {
  return state.set('focusTitleAndInstructions', payload.status);
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    // two types for event logging differentiation
    case RESPONSE:
    case PREVIEW_RESPONSE:
      return modifyResponse(state, action.payload);
    case ACTIVE_QUIZ_SESSION_CHANGE:
      return activeQuizSessionChange(state, action.payload);
    case PREVIOUS_QUESTION:
      return previousQuestion(state, action.payload);
    case BACKTRACKING_NEXT_QUESTION:
      return backtrackingNextQuestion(state, action.payload);
    case LOAD_RESUME_DATA:
      return loadResponses(state, action.payload);
    case SESSION_STARTED_OR_RESUMED_EVENT:
      return markSessionStartedIdentifier(state, action.payload);
    case UPDATE_IS_TAKING:
      return updateIsTaking(state, action.payload);
    case UPDATE_TIMER_MINIMIZED:
      return updateTimerMinimized(state, action.payload);
    case UPDATE_TIMER_INFO:
      return updateTimerInfo(state, action.payload);
    case SET_WS_TOKEN:
      return setWSToken(state, action.payload);
    case SET_CURRENT_SESSION_ITEM_POSITION:
      return setCurrentSessionItemPosition(state, action.payload);
    case CLEAR_FOCUS_CURRENT_SESSION_ITEM:
      return clearFocusCurrentSessionItem(state, action.payload);
    case UPDATE_QUIZ_SESSION_STATUS_ON_PAGE_LOAD:
      return updateQuizSessionStatusOnPageLoad(state, action.payload);
    case UPDATE_QUIZ_SUBMIT_FLAG:
      return updateQuizSubmitFlag(state, action.payload);
    case SET_FOCUS_TITLE_AND_INSTRUCTIONS:
      return setFocusTitleAndInstructions(state, action.payload);
    default:
      return state;
  }
});